import { render, staticRenderFns } from "./UnderMaintenance.vue?vue&type=template&id=4f4711e2"
var script = {}
import style0 from "./UnderMaintenance.vue?vue&type=style&index=0&id=4f4711e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports